/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./empty-table-message.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./empty-table-message.component";
var styles_EmptyTableMessageComponent = [i0.styles];
var RenderType_EmptyTableMessageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_EmptyTableMessageComponent, data: {} });
export { RenderType_EmptyTableMessageComponent as RenderType_EmptyTableMessageComponent };
export function View_EmptyTableMessageComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_EmptyTableMessageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-empty-table-message", [], null, null, null, View_EmptyTableMessageComponent_0, RenderType_EmptyTableMessageComponent)), i1.ɵdid(1, 114688, null, 0, i2.EmptyTableMessageComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var EmptyTableMessageComponentNgFactory = i1.ɵccf("cc-empty-table-message", i2.EmptyTableMessageComponent, View_EmptyTableMessageComponent_Host_0, {}, {}, ["*"]);
export { EmptyTableMessageComponentNgFactory as EmptyTableMessageComponentNgFactory };
